import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import { useHistory } from "react-router-dom";
import { InsuranceReport } from "../InsuranceNew/InsuraceDashboardComponents/InsuranceReport";
import { InsuranceInfo } from "../InsuranceNew/InsuraceDashboardComponents/InsuranceInfo";
import { InsuranceTableV2 } from "./InsuranceTableV2";
import NewLoader from "../../components/styled-components/loader/NewLoader";
import { MODULE_API } from "../../apis";
import FETCH from "../../utils/fetch";
import swal from "sweetalert";
import "../InsuranceNew/InsuranceDashboard.css";
import { GlobalLoaderContext } from "../../utils/GlobalLoaderContext";
import ModalVideo from "../ModuleVideos/ModalVideo";
import { LoadingOutlined } from "@ant-design/icons";

export const InsuranceMainDashboard = () => {
  const history = useHistory();
  const { runWithLoader } = useContext(GlobalLoaderContext);
  const reportRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [insuranceData, setInsuranceData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [cachedData, setCachedData] = useState({});
  const [stats, setStats] = useState({})
  const [totalPremium, setTotalPremium] = useState(null)
  const [fetchChartData, setFetchChartData] = useState(false)

  const handleDownloadReport = useCallback(() => {
    if (downloadLoading) return;
    if (reportRef.current && typeof reportRef.current.downloadPDF === "function") {
      reportRef.current.downloadPDF();
    }
  }, [downloadLoading]);

  const handleDownloadLoading = useCallback((loading) => {
    setDownloadLoading(loading);
  }, []);

  const getInsuranceList = async (page) => {
    if (cachedData && cachedData[page]) {
      setLoading(false);
      updateStateWithData(cachedData[page]);
      return;
    }
    try {
      setLoading(true);
      const userRole =
      localStorage.getItem("role") != "undefined" &&
      JSON.parse(localStorage.getItem("role"));
    const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id: userRole === "Financial Advisor Client"
            ? `?module=Insurance Products V2&page=${page}&limit=10&clientId=${ID}`
            : `?module=Insurance Products V2&page=${page}&limit=10`,
        body: {},
      });
      if (datares && datares.records) {
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithData(datares);
      }
      setLoading(false);

    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const updateStateWithData = (datares) => {
    if (datares && datares.records) {
      setInsuranceData(datares.records);
    }
    if (datares && datares.pagination) {
      setTotalPages(
        Math.ceil(datares.pagination.total / datares.pagination.limit)
      );
    }
  };
  const getInsuarnceListAfterDelete = async (page) => {
    try {
      setLoading(true);
      const userRole =
      localStorage.getItem("role") != "undefined" &&
      JSON.parse(localStorage.getItem("role"));
    const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id: userRole === "Financial Advisor Client"
            ? `?module=Insurance Products V2&page=${page}&limit=10&clientId=${ID}`
            : `?module=Insurance Products V2&page=${page}&limit=10`,
        body: { },
      });
      if (datares && datares.records) {
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithData(datares);
        getInsuarnceStats()
        getInsuarnceSum()
        setFetchChartData(!fetchChartData);
      }
      await getInsuarnceStats()
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getInsuarnceStats = async () => {
    try {
      setLoading(true);
      const datares = await MODULE_API.fetchInsuranceStats()
      if (datares && datares.data) {
        setStats(datares.data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getInsuarnceSum = async () => {
    try {
      setLoading(true);
      const datares = await MODULE_API.fetchInsuranceSum()
      if (datares && datares.data && datares.data.totalPremium) {
        setTotalPremium(datares.data.totalPremium);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const deletePost = async (id) => {
    console.log("delete is", id);
    swal({
      title: "Are you sure?",
      text: "You want to delete this?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (result) => {
      if (result === true) {
        setLoading(true);
        try {
          const res = await MODULE_API.removeClientModule({
            clientModules: [id],
          });
          setCachedData({});
          setInsuranceData([]);
          await getInsuarnceListAfterDelete(1);
        } catch (error) {
          setLoading(false);
        }
      }
    });
  };
   useEffect(() => {
      const fetchData = async () => {
        await runWithLoader(async () => {
          await getInsuranceList(currentPage);
          await getInsuarnceStats();
          await getInsuarnceSum();
          }, () => {
          // 👇 This runs only if global loader actually shows after 4s
          setLoading(false);
        });
      };

      fetchData();
   }, [currentPage]);

  return (
    <div className="insuranceMain">
    <ModalVideo module="Insurance" autoOpen={true} />
      <div className="liabilitycreate" style={{ display: "flex", gap:"1rem", alignItems: "center" }}>
        <button
          className="addbuttonLiablity"
          onClick={() => {
            history.push("/organizer/insurance/add");
          }}
        >
          {" "}
          + Add Insurance
        </button>

        <button
          className={`addbuttonassets addbuttonassets--secondary assets-download-button${
            (downloadLoading || loading) ? " addbuttonassets--loading" : ""
          }`}
          style={{ margin: 0, padding: "0.5rem" }}
          disabled={downloadLoading || loading}
          onClick={handleDownloadReport}
          aria-busy={downloadLoading || loading}
          aria-live="polite"
        >
          <span className="assets-download-icon-shell" aria-hidden="true">
            {downloadLoading ? (
              <LoadingOutlined
                className="assets-download-icon"
                style={{ color: "#ffffff" }}
                spin
              />
            ) : (
              <svg
                className="assets-download-icon assets-download-svg-icon"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M12 4.5V14.5"
                  stroke="currentColor"
                  strokeWidth="2.25"
                  strokeLinecap="round"
                />
                <path
                  d="M8.5 11.5L12 15L15.5 11.5"
                  stroke="currentColor"
                  strokeWidth="2.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6 18.5H18"
                  stroke="currentColor"
                  strokeWidth="2.25"
                  strokeLinecap="round"
                />
              </svg>
            )}
          </span>
          {downloadLoading ? "Downloading..." : "Download Report"}
        </button>
      </div>
      <div className="insuranceMainReport" style={{position:"relative"}}>
        <InsuranceReport ref={reportRef} stats={stats} totalPremium={totalPremium} onDownloadLoading={handleDownloadLoading} />
        <NewLoader isLoading={loading} />
      </div>
      <div className="insruance-info-main" style={{position:"relative"}}>
        <InsuranceInfo fetchChartData={fetchChartData} />
        <NewLoader isLoading={loading} />
      </div>
      <div className="insuranceCreditMainTag" style={{position:"relative"}}>
        <InsuranceTableV2
          deletePost={deletePost}
          data={insuranceData && insuranceData}
          isLoading={loading}
          getList={getInsuranceList}
          page={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
        />
        <NewLoader isLoading={loading} />
      </div>
      {/* <div className="liabilityTableCard">
        <LiabilityTable />
        </div>  */}
    </div>
  );
};
